import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import Checkbox from '@material-ui/core/Checkbox';
import LocalizedStrings from './localization.js';
import backgroundPattern from './images/background-pattern.png';
import Icon, { IconButton } from '@projeccions-pdc/react-icon';

const styles = theme => ({
    titleBar: {
        height: 'auto',
    },
    title: {
        fontSize: '12px',
        lineHeight: '20px',
    }
});

const imgStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundImage: `url(${backgroundPattern})`,
};

class LibraryFile extends Component {
    handleClick = evt => {
        this.props.onResultSelected(this.props.resource, evt);
    };

    renderBoolean = (value) => {
        if (value === true) {
            return (
                <Icon primaryColor='#21ba45' name='fa-check' />
            );
        }
        return (
            <Icon primaryColor='#db2828' name='fa-close' />
        );
    }

    handleOpenItem = (evt) => {
        if (this.props.onItemClick) {
            evt.stopPropagation();
            this.props.onItemClick(evt, this.props.resource.fileId);
        }
    }

    render() {
        const columnData = {};
        this.props.columnData.forEach((column) => {
            columnData[column.id] = {};
        });
        return (
            <GridListTile
                cols={1}
                rows={1}
                onClick={this.handleClick}
                data-id={this.props.resource.fileId}
                data-type="data-grid-item"
                {...{ style: this.props.style }}>
                <div style={{ position: 'absolute', zIndex: 1 }}>
                    <Checkbox
                        checked={this.props.isSelected}
                        color="primary"
                    />
                </div>
                {this.props.onItemClick ?
                    <div style={{ position: 'absolute', zIndex: 1, right: '10px', top: '10px' }}>
                        <IconButton data-id="library-file-detail-btn" name='md-edit' size='20px' onClick={this.handleOpenItem} />
                    </div>
                    : ''}
                {this.props.src ? (
                    <img
                        src={this.props.src}
                        alt={this.props.resource.filename}
                        style={imgStyle}
                    />
                ) :
                    (
                        <div
                            style={{
                                height: '100%',
                                width: '100%',
                                backgroundColor: '#f5f5f5'
                            }}
                        />
                    )}
                <GridListTileBar
                    title={
                        <div>
                            {columnData.filename ?
                                <div>
                                    {this.props.resource.filename}
                                </div>
                                : ''}
                            {columnData.dateCreated ? <div>{new Date(this.props.resource.dateCreated).toLocaleString()}</div> : ''}
                            {columnData.userSub ? <div>{this.props.uploadedBy}</div> : ''}
                            <div>
                                {columnData.inUse ?
                                    <span>
                                        {`${LocalizedStrings.use}: `}
                                        {this.renderBoolean(this.props.resource.inUse)}
                                    </span>
                                    : ''}
                                {columnData.shareable ?
                                    <span>
                                        {` ${LocalizedStrings.shareable}: `}
                                        {this.renderBoolean(this.props.resource.shareable)}
                                    </span>
                                    : ''}
                                {columnData.menu ?
                                    <span>
                                        {` ${LocalizedStrings.menu}: `}
                                        {this.renderBoolean(this.props.resource.menu)}
                                    </span>
                                    : ''}

                            </div>
                            <div>
                                {columnData.url ?
                                    <a target='_blank' rel="noopener noreferrer" href={this.props.resource.url}>
                                        <Icon name='fa-eye' primaryColor='#fff' />
                                    </a>
                                    : ''}
                            </div>
                        </div>
                    }
                    classes={{
                        root: this.props.classes.titleBar,
                        title: this.props.classes.title,
                    }}
                />
            </GridListTile>
        );
    }
}
LibraryFile.propTypes = {
    isSelected: PropTypes.bool.isRequired,
    src: PropTypes.string,
    resource: PropTypes.object.isRequired,
    onResultSelected: PropTypes.func.isRequired,
    uploadedBy: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    style: PropTypes.object,
    columnData: PropTypes.array.isRequired,
    onItemClick: PropTypes.func,
};

export default withStyles(styles)(LibraryFile);